import {AxiosError} from 'axios'
import {UseMutationOptions} from 'react-query'

import {API} from '../../../networking/http'
import {MembershipCancelRequest} from '../types'

export type CreateMembershipCancelRequestOptions = {
  subscriptionId: string
  reason: string
}

export type CreateMembershipCancelRequestMutationReturnType = MembershipCancelRequest

export const createMembershipCancelRequestEndpoint = (subscriptionId: string) =>
  `memberships/${subscriptionId}/cancel-requests`

export type CreateMembershipCancelRequestMuOp = UseMutationOptions<
  CreateMembershipCancelRequestMutationReturnType,
  AxiosError,
  CreateMembershipCancelRequestOptions
>

export const createMembershipCancelRequest = (
  params?: CreateMembershipCancelRequestMuOp,
): CreateMembershipCancelRequestMuOp => ({
  mutationFn: async (options) => {
    const res = await API.post<{reason: string}, CreateMembershipCancelRequestMutationReturnType>(
      createMembershipCancelRequestEndpoint(options.subscriptionId),
      {reason: options.reason},
    )
    return res.data
  },
  ...params,
})
